import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { callHistoryQueryKeys } from './queryKeys';

const getCallRecord = async (uniqueId) => {
  return await request.get(
    `/Phone/record/${uniqueId}`,
    {},
    'При загрузке записи произошла ошибка',
    'Error'
  );
};

const useCallRecord = (uniqueId, options) => {
  return useQuery(
    callHistoryQueryKeys.callRecord(uniqueId),
    () => getCallRecord(uniqueId),
    options
  );
};

export default useCallRecord;
